module.exports = __webpack_public_path__ + "img/digital-signature.90e476b7.png";